import { FC } from "react";
import { Box } from "@mui/material";
import useBasePath from "src/utils/hooks/useBasePath";
import __ from "src/utils/Translations";
import BreadcrumbsMui from "src/Components/BreadcrumbsMui/BreadcrumbsMui";
import Title from "src/Pages/Company/Absences/Title/Title";
import ImportForm from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecordsImports/ImportForm";
import {
  ExportType,
  ImportType,
} from "src/Pages/Company/Absences/AbsenceRecords/AbsenceRecords.models";
import ExportForm from "./ExportForm";

const AbsenceRecordsPatternsImport: FC = () => {
  const basePath = useBasePath();

  return (
    <Box
      sx={{ position: "relative" }}
      data-testid="absence-records-patterns-import"
    >
      <BreadcrumbsMui
        items={[
          {
            label: __("Nieobecności"),
            to: `${basePath}/absences`,
          },
          {
            label: __("Kartoteki pracowników"),
            to: `${basePath}/absences/absence-records`,
          },
          {
            label: __("Eksport i import wzorców i wymiarów"),
          },
        ]}
      />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Title
          title={__("Eksport i import wzorców i wymiarów")}
          subtitle={__("Eksport i zbiorcza aktualizacja wzorców i wymiarów")}
        />
      </Box>
      <ExportForm exportType={ExportType.PATTERNS} hasYearsFilter={false} />
      <ImportForm importType={ImportType.EMPLOYEE_ABSENCE_CONFIGURATION} />
    </Box>
  );
};

export default AbsenceRecordsPatternsImport;
